import React from 'react';
import Rock from './Components/Rock';
import Paper from "./Components/Paper";
import Scissors from "./Components/Scissors";
import Lizard from "./Components/Lizard";
import Spock from "./Components/Spock";
import './App.css';
import Modal from './Components/Modal';

function App() {
  //const var1 = JSON.parse(localStorage.getItem("score"));
  //const var2 = JSON.parse(localStorage.getItem("prevScore"));
  const [modal,setModal] = React.useState(false);
  const [game,setGame] = React.useState(false);
  const [player,setPlayer] = React.useState(0);
  const [ran_num,setRan_num] = React.useState(4);
  const [hide,setHide] = React.useState(true);
  const [won,setWon] = React.useState(false);
  const [draw,isDraw] = React.useState(false);
  const [score,setScore]= React.useState(0);
  const [prevScore,setPrevScore] = React.useState(0);
  const icons= [<Scissors />, <Paper />, <Rock />, <Lizard />, <Spock />];
  const bord_colors = ["#EEA41D","#5671F5","#DD3C57","#8D59E8","#4BBCCF"];
  function showModal(){
    setModal(prev=>!prev);
  }
  function gameLogic(c1,c2){
    //0=>Scissor , 1=>Paper, 2=>Rock, 3=>Lizard, 4=>Spock
    if(c1===c2){
      isDraw(true);
    }
    else{
      switch(c1){
        case 0:
          //(c2===1||c2===3)?(setWon(true)):(setWon(false));
          if(c2===1||c2===3){
            setWon(true);
            setScore(prev=>prev+1);
          }
          else{
            setWon(false);
            setScore(prev=>prev-1);
          }
          break;
        case 1:
          //(c2===2||c2===4)?(setWon(true)):(setWon(false));
          if(c2===2||c2===4){
            setWon(true);
            setScore(prev=>prev+1);
          }
          else{
            setWon(false);
            setScore(prev=>prev-1);
          }
          break;
        case 2:
          //(c2===3||c2===0)?(setWon(true)):(setWon(false));
          if(c2===3||c2===0){
            setWon(true);
            setScore(prev=>prev+1);
          }
          else{
            setWon(false);
            setScore(prev=>prev-1);
          }
          break;
        case 3:
          // (c2===4||c2===1)?(setWon(true)):(setWon(false));
          if(c2===4||c2===1){
            setWon(true);
            setScore(prev=>prev+1);
          }
          else{
            setWon(false);
            setScore(prev=>prev-1);
          }
          break;
        case 4:
          //(c2===0||c2===2)?(setWon(true)):(setWon(false));
          if(c2===0||c2===2){
            setWon(true);
            setScore(prev=>prev+1);
          }
          else{
            setWon(false);
            setScore(prev=>prev-1);
          }
          break;    
        default:
          console.log("never happening!");
          break;       
      }
    }   
  }
  function playerChoice(choice){
    setGame(prev=>!prev);
    setPlayer(choice);
    let x= Math.floor(Math.random()*5);
    setRan_num(x);
    console.log(choice);
    console.log(x);
    gameLogic(choice,x);
    setTimeout(()=>setHide(false),2000);
  }
  //keeping track of score evenn on refresh!
  // React.useEffect(()=>{
  //   localStorage.setItem('score',JSON.stringify(score));
  //   localStorage.setItem('prevScore',JSON.stringify(prevScore));
  // },[score,prevScore])
  return (
    <main style={modal?{backgroundColor:"#0B1121"}:{}} className=" bar relative text-white bg-[#1D2D4E] flex flex-col justify-center items-center  h-screen w-screen">
      <section style={modal?{opacity:"25%"}:{}} className=' h-screen w-10/12   md:w-7/12'>
        <section className=' head flex  justify-between items-center grayBord rounded-xl px-4 py-4 h-1/4  '>
        <div className='title child:text-xl child:leading-4  md:child:text-3xl md:child:leading-6'>
          <h2>ROCK</h2>
          <h2>PAPER</h2>
          <h2>SCISSORS</h2>
          <h2>LIZARD</h2>
          <h2>SPOCK</h2>
        </div>
        <div className='score bg-white flex flex-col justify-evenly items-center md:w-2/12 rounded-xl h-[84px]  md:h-[124px] px-4 py-4  '>
          <h3 className=' text-[#2943A5] tracking-wide text-xl'>SCORE</h3>
          <h2 className=' text-[#545163] text-5xl md:text-6xl font-semibold '>{!hide?score:prevScore}</h2>
        </div>
        </section>
        {!game?<section className=' buttons   relative child:cursor-pointer   pent bg-contain md:bg-auto h-3/4'>
          <div onClick={()=>playerChoice(4)} className=' bg-white border-[11px] border-[#4BBCCF] top-[32.5%] md:top-[36.5%] right-[72.5%]  md:right-[62.5%]   absolute  w-28 flex items-center justify-center  h-28 rounded-full'>
          <Spock />
          </div>
          <div onClick={()=>playerChoice(1)} className=' bg-white border-[11px] border-[#5671F5] top-[32.5%] md:top-[37.5%] left-[72.5%]  md:left-[62.5%]   absolute  w-28 flex items-center justify-center  h-28 rounded-full'>
          <Paper />
          </div>
          <div onClick={()=>playerChoice(0)} className=' bg-white border-[11px] border-[#EEA41D] md:top-[12.5%] top-[5%]  left-[38.5%] md:left-[45%]    absolute  w-28 flex items-center justify-center  h-28 rounded-full'>
          <Scissors />
          </div>
          <div onClick={()=>playerChoice(2)} className=' bg-white border-[11px] border-[#DD3C57] top-[72.5%] md:top-[70%] left-[65%] md:left-[55%]    absolute  w-28 flex items-center justify-center  h-28 rounded-full'>
          <Rock />
          </div>
          <div onClick={()=>playerChoice(3)} className=' bg-white border-[11px] border-[#8D59E8] top-[72.5%] md:top-[70%]   right-[65%] md:right-[55%]    absolute  w-28 flex items-center justify-center  h-28 rounded-full'>
          <Lizard />
          </div>
        </section>
        :<section className=' h-[69%] md:h-3/4    flex flex-col justify-center items-center'>
         <section  className=' w-full h-full  relative child:my-8 flex items-start md:items-center  justify-center  '> 
          <div className=' player-choice relative flex flex-col-reverse md:flex-col w-full items-center child:my-4    justify-between'>
            <h2 className=' text-lg md:text-2xl  tracking-wider text-white'>YOU PICKED</h2>
            <div id="player" style={{borderColor:bord_colors[player]}} className= {` ${draw?"":(!hide?(won?"butt":""):"")} bg-white border-[12px] md:border-[20px] w-28 md:w-60 flex items-center justify-center h-28 md:h-60 rounded-full `}>
              {icons[player]}
            </div>  
          </div>
          {!hide?
          <div className=' result w-full absolute   bottom-[-10%]   md:static flex flex-col child:my-2 justify-center items-center '>
            {
            draw?
               <h2 className=' text-4xl md:text-5xl  tracking-wide'>IT'S A DRAW</h2>
            :
              <h2 className=' text-4xl md:text-5xl  tracking-wide'>YOU {won?"WIN":"LOSE"}</h2>
            }
            <button onClick={()=>{setGame(prev=>!prev);setHide(true);isDraw(false);setPrevScore(score)}} className=' text-xl w-1/2 md:w-3/4 py-2 px-2 rounded-xl bg-white text-[#626374] tracking-wider'>PLAY AGAIN</button>
          </div>:null}
          <div className=' cpu-choice relative  flex flex-col-reverse md:flex-col w-full text-center child:my-4 items-center justify-between  '>
          <h2 className=' text-lg md:text-2xl tracking-wider text-white'>THE HOUSE PICKED</h2>
          {!hide?<div id="cpu" style={{borderColor:bord_colors[ran_num]}} className={` ${draw?"":(won?"":"butt")} bg-white   border-[12px] md:border-[20px] w-28 md:w-60 flex items-center justify-center h-28 md:h-60 rounded-full`}>
              {icons[ran_num]}
          </div>:<div  className=' bg-[#192835] border-[12px] md:border-[20px] w-28 md:w-60 flex items-center justify-center h-28 md:h-60 rounded-full'>
              
          </div>}
          
          </div>
          </section>
        </section>}  
      </section>
      <section style={modal?{opacity:"25%"}:{}} className='rules flex w-full px-4 py-2   justify-center md:justify-end'>
          <button onClick={showModal} className=' tracking-widest text-2xl  px-6 py-2 bg-transparent rounded-xl border-white border-4 text-white'>RULES</button>
      </section>
      {modal?<Modal click={showModal} />:<></>}
    </main>
  );
}

export default App;
